import React from 'react';
import Counter from '../ReusableComponents/counter';

//MUI
import { styled } from '@mui/material/styles';
import { Box, Typography } from '@mui/material';
import { Container } from '@mui/system';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import Collapse from '@mui/material/Collapse';
import IconButton from '@mui/material/IconButton';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import Button from '@mui/material/Button';
//Images
import im1 from '../../assets/images/SDG/1.jpg';
import im3 from '../../assets/images/SDG/3.jpg';
import im4 from '../../assets/images/SDG/4.jpg';
import im5 from '../../assets/images/SDG/5.jpg';
import im8 from '../../assets/images/SDG/8.jpg';
import im11 from '../../assets/images/SDG/11.jpg';
import im16 from '../../assets/images/SDG/16.jpg';
import P3 from '../../assets/images/cardImages/wellbeing.jpg';
import P3_small from '../../assets/images/cardImages/mobile/wellbeing.jpg';
import bg from '../../assets/images/background.svg'
import SchoolRoundedIcon from '@mui/icons-material/SchoolRounded';
import WestIcon from '@mui/icons-material/West';
import EastIcon from '@mui/icons-material/East';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import ArrowDropUpIcon from '@mui/icons-material/ArrowDropUp';
import AssessmentOutlinedIcon from '@mui/icons-material/AssessmentOutlined';
import HealthAndSafetyIcon from '@mui/icons-material/HealthAndSafety';
import EngineeringIcon from '@mui/icons-material/Engineering';

//chart js
import { Chart as ChartJS, CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend, ArcElement, } from 'chart.js';
import { Bar } from 'react-chartjs-2';
import ChartDataLabels from 'chartjs-plugin-datalabels';

const ExpandMore = styled((props) => {
    const { expand, ...other } = props;
    return <IconButton {...other} />;
})(({ theme, expand }) => ({
    transform: !expand ? 'rotate(0deg)' : 'rotate(180deg)',
    marginLeft: 'auto',
    transition: theme.transitions.create('transform', {
        duration: theme.transitions.duration.shortest,
    }),
}));


const counterData = [
    {
        "num": 100,
        "label": "Employees/ workers covered under Health Benefits and Retirement Benefits",
        "icon": HealthAndSafetyIcon,
        "prefix": "",
        "isdecimal": false,
        "suffix": "%"
    },
    {
        "num": 100,
        "label": "Return to work rate",
        "icon": EngineeringIcon,
        "prefix": "",
        "isdecimal": true,
        "suffix": "%"
    },
    {
        "num": 86.28,
        "label": "Employees were given training on Skill upgradation",
        "icon": SchoolRoundedIcon,
        "prefix": "",
        "isdecimal": true,
        "suffix": "%"
    },
]

const StyledBox = styled(Box)`
  ${({ theme }) => `
  cursor: pointer;
  transition: ${theme.transitions.create(['transform'], {
    duration: theme.transitions.duration.standard,
})};
  &:hover {
    transform: scale(1.8);
  }
  `}
`;

ChartJS.register(
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend,
    ChartDataLabels
);

ChartJS.register(ArcElement, Tooltip, Legend);

//------------------------------------------------

export const options1 = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
        title: {
            display: false,
            text: 'Training',
        },
        legend: {
            position: 'top',
            labels: {
                font: {
                    family: 'Georama'
                }
            }
        },
        datalabels: {
            anchor: 'center',
            align: 'bottom',
            formatter: (value, context) => {
                let keys = Object.keys(context.dataset.data)
                let key = keys[context.dataIndex]
                if (context.dataset.data[key] !== 0) {
                    return context.dataset.data[key].toLocaleString('en-In') + "%";
                }

            },
            padding: -10,
            color: "white",
            font: {
                family: 'Georama',
                size: 11,
                weight: 'bold',

            }
        }
    },
    scales: {
        x: {
            grid: {
                display: false
            },
            ticks: {
                font: {
                    family: 'Georama'
                }
            }
        },
        y: {
            display: true,

            grid: {
                display: true,
            },
            ticks: {
                font: {
                    family: 'Georama'
                }
            }
        },
    },
};

const labels1 = ['Male', 'Female', 'Total'];

export const data1 = {
    labels1,
    datasets: [
        {
            label: 'FY23',
            data: {
                "Male": 66.42,
                "Female": 70.17,
                "Total": 66.58
            },
            backgroundColor: '#747474',
            barThickness: 50
        },
        {
            label: 'FY24',
            data: {
                "Male": 88.61,
                "Female": 93.64,
                "Total": 88.93
            },
            backgroundColor: '#4d4d4f',
            barThickness: 50
        },
        {
            label: 'FY25',
            data: {
                "Male": 93.52,
                "Female": 74,
                "Total": 91.48
            },
            backgroundColor: '#e31837',
            barThickness: 50
        },
    ],
};

const Sectionc3 = () => {

    const [expanded1, setExpanded1] = React.useState(false);
    const handleExpandClick1 = () => {
        setExpanded1(!expanded1);
    };

    const [expanded2, setExpanded2] = React.useState(false);
    const handleExpandClick2 = () => {
        setExpanded2(!expanded2);
    };

    const [expanded1c, setExpanded1c] = React.useState(false);
    const handleExpandClick1c = () => {
        setExpanded1c(!expanded1c);
    };

    const [expanded3, setExpanded3] = React.useState(false);
    const handleExpandClick3 = () => {
        setExpanded3(!expanded3);
    };


    const [expanded4, setExpanded4] = React.useState(false);
    const handleExpandClick4 = () => {
        setExpanded4(!expanded4);
    };

    const [expanded5, setExpanded5] = React.useState(false);
    const handleExpandClick5 = () => {
        setExpanded5(!expanded5);
    };

    const [expanded6, setExpanded6] = React.useState(false);
    const handleExpandClick6 = () => {
        setExpanded6(!expanded6);
    };

    const [expanded7, setExpanded7] = React.useState(false);
    const handleExpandClick7 = () => {
        setExpanded7(!expanded7);
    };

    const [expanded8, setExpanded8] = React.useState(false);
    const handleExpandClick8 = () => {
        setExpanded8(!expanded8);
    };

    const [expanded9, setExpanded9] = React.useState(false);
    const handleExpandClick9 = () => {
        setExpanded9(!expanded9);
    };

    const [expanded9g, setExpanded9g] = React.useState(false);
    const handleExpandClick9g = () => {
        setExpanded9g(!expanded9g);
    };

    const [expanded10, setExpanded10] = React.useState(false);
    const handleExpandClick10 = () => {
        setExpanded10(!expanded10);
    };

    const [expanded12, setExpanded12] = React.useState(false);
    const handleExpandClick12 = () => {
        setExpanded12(!expanded12);
    };

    const [expanded15, setExpanded15] = React.useState(false);
    const handleExpandClick15 = () => {
        setExpanded15(!expanded15);
    };

    const [expanded16, setExpanded16] = React.useState(false);
    const handleExpandClick16 = () => {
        setExpanded16(!expanded16);
    };

    const [expanded17, setExpanded17] = React.useState(false);
    const handleExpandClick17 = () => {
        setExpanded17(!expanded17);
    };

    const [expanded18, setExpanded18] = React.useState(false);
    const handleExpandClick18 = () => {
        setExpanded18(!expanded18);
    };

    const [expanded19, setExpanded19] = React.useState(false);
    const handleExpandClick19 = () => {
        setExpanded19(!expanded19);
    };

    const [expanded20, setExpanded20] = React.useState(false);
    const handleExpandClick20 = () => {
        setExpanded20(!expanded20);
    };

    const [expanded21, setExpanded21] = React.useState(false);
    const handleExpandClick21 = () => {
        setExpanded21(!expanded21);
    };

    const [expanded22, setExpanded22] = React.useState(false);
    const handleExpandClick22 = () => {
        setExpanded22(!expanded22);
    };

    const [expanded23, setExpanded23] = React.useState(false);
    const handleExpandClick23 = () => {
        setExpanded23(!expanded23);
    };

    const [expanded24, setExpanded24] = React.useState(false);
    const handleExpandClick24 = () => {
        setExpanded24(!expanded24);
    };

    const [expanded25, setExpanded25] = React.useState(false);
    const handleExpandClick25 = () => {
        setExpanded25(!expanded25);
    };

    const [expand, setExpand] = React.useState(false);
    const expandAll = () => {
        setExpand(true); setExpanded1(true); setExpanded2(true); setExpanded3(true); setExpanded4(true); setExpanded5(true); setExpanded6(true); setExpanded7(true); setExpanded8(true); setExpanded9(true); setExpanded9g(true); setExpanded10(true); setExpanded12(true); setExpanded15(true); setExpanded16(true); setExpanded17(true); setExpanded18(true); setExpanded19(true); setExpanded20(true); setExpanded21(true); setExpanded22(true); setExpanded23(true); setExpanded24(true); setExpanded25(true);
        setExpanded1c(true);
    };
    const closeAll = () => {
        setExpand(false); setExpanded1(false); setExpanded2(false); setExpanded3(false); setExpanded4(false); setExpanded5(false); setExpanded6(false); setExpanded7(false); setExpanded8(false); setExpanded9(false); setExpanded9g(false); setExpanded10(false); setExpanded12(false); setExpanded15(false); setExpanded16(false); setExpanded17(false); setExpanded18(false); setExpanded19(false); setExpanded20(false); setExpanded21(false); setExpanded22(false); setExpanded23(false); setExpanded24(false); setExpanded25(false);
        setExpanded1c(false);

    };


    return (
        <Container>
            <Box mt={3} sx={{ display: 'flex', justifyContent: 'space-between' }}>
                <Button startIcon={<WestIcon />} sx={{ fontWeight: 'bold' }} href='/sectionc2'>
                    Previous
                </Button>
                <Button endIcon={<EastIcon />} sx={{ fontWeight: 'bold' }} href='/sectionc4'>
                    Next
                </Button>
            </Box>
            <Box mt={3} sx={{
                display: 'flex',
                alignItems: 'center',
                height: { xs: '150px', md: '300px' },
                backgroundImage: `url(${bg})`,
                backgroundSize: 'cover',
                borderRadius: '8px'
            }}>
                <Box px={5} py={3} sx={{ width: '100%' }}>
                    <Typography sx={{ typography: { xs: 'h5', md: 'h4' }, color: "#ffffff" }}>
                        Principle 3
                    </Typography>
                    <Typography mt={2} sx={{ typography: { xs: 'body1', md: 'h6' }, color: "#ffffff" }}>
                        Employee Wellbeing
                    </Typography>
                    <Box mt={2} sx={{ display: { xs: 'none', lg: 'flex' } }}>
                        <Typography variant='body1' sx={{ color: "#ffffff" }}>
                            Businesses should respect and promote the well-being of all employees,
                            including those in their value chains
                        </Typography>
                    </Box>
                    <Box mt={3} sx={{ display: { xs: 'none', lg: 'flex' } }}>
                        <StyledBox> <img src={im1} height="40" alt="svg" /></StyledBox>
                        <StyledBox> <img src={im3} height="40" alt="svg" /></StyledBox>
                        <StyledBox> <img src={im4} height="40" alt="svg" /></StyledBox>
                        <StyledBox> <img src={im5} height="40" alt="svg" /></StyledBox>
                        <StyledBox> <img src={im8} height="40" alt="svg" /></StyledBox>
                        <StyledBox> <img src={im11} height="40" alt="svg" /></StyledBox>
                        <StyledBox> <img src={im16} height="40" alt="svg" /></StyledBox>
                    </Box>
                </Box>
                <Box sx={{
                    backgroundImage: { xs: `url(${P3_small})`, sm: `url(${P3})` },
                    backgroundSize: 'cover',
                    borderRadius: '0 8px 8px 0',
                    height: { xs: '150px', md: '300px' },
                    width: '100%'
                }}>
                </Box>
            </Box>

            <Box px={4} py={6} mt={{ xs: 4, md: 8 }} sx={{ backgroundColor: '#e6e7e8', borderRadius: '8px' }}>
                <Box mb={6} display="flex" justifyContent="center">
                    <Typography className='heading' variant='h4' sx={{ color: "#e31837", fontSize: "34px", fontWeight: "900" }}>
                        Highlights
                    </Typography>
                </Box>
                <Box>
                    <Counter data={counterData} />
                </Box>
            </Box>
            <Box mt={5} sx={{ textAlign: "right" }}>
                <button onClick={!expand ? expandAll : closeAll} className="custom-button">
                    <span>
                        {!expand ? 'Expand All' : "Close All"}
                        {!expand ? <ArrowDropDownIcon /> : <ArrowDropUpIcon />}
                    </span>
                </button>
            </Box>
            <Box mt={4}>
                <Typography className='heading' variant='h4' sx={{ fontSize: '28px', color: "#e31837" }}>
                    Essential Indicators
                </Typography>
            </Box>
            <Box mt={2} sx={{ borderBottom: 1, borderColor: "#d3d3c8" }}>
                <Box mb={2}>
                    <Box>
                        <Typography variant='body1' sx={{ fontWeight: 'bold', color: "#e31837" }}>
                            1. a. Details of measures for the well-being of employees
                            <ExpandMore
                                expand={expanded1}
                                onClick={handleExpandClick1}
                                aria-expanded={expanded1}
                                aria-label="show more"
                            >
                                <ExpandMoreIcon />
                            </ExpandMore>
                        </Typography>
                    </Box>
                </Box>
                <Collapse in={expanded1} timeout="auto" unmountOnExit>
                    <Box mb={5}>
                        <TableContainer component={Paper}>
                            <Table sx={{ minWidth: 650 }} size="small" aria-label="Water withdrawal">
                                <TableHead sx={{ "& th": { color: '#FFFFFF' } }}>
                                    <TableRow sx={{ backgroundColor: "#4d4d4f" }}>
                                        <TableCell align='center' rowSpan={3}><strong>Category</strong></TableCell>
                                        <TableCell align="center" colSpan={11}><strong>% of employees covered by</strong></TableCell>
                                    </TableRow>
                                    <TableRow sx={{ backgroundColor: "#4d4d4f" }}>
                                        <TableCell align='center' rowSpan={2}><strong>Total (A) </strong></TableCell>
                                        <TableCell align="center" colSpan={2}><strong>Health insurance</strong></TableCell>
                                        <TableCell align="center" colSpan={2}><strong>Accident insurance</strong></TableCell>
                                        <TableCell align="center" colSpan={2}><strong>Maternity benefits</strong></TableCell>
                                        <TableCell align="center" colSpan={2}><strong>Paternity Benefits</strong></TableCell>
                                        <TableCell align="center" colSpan={2}><strong>Day Care facilities</strong></TableCell>
                                    </TableRow>
                                    <TableRow sx={{ backgroundColor: "#4d4d4f" }}>
                                        <TableCell align="center"><strong>No. (B) </strong></TableCell>
                                        <TableCell align="center"><strong>% (B/A)</strong></TableCell>
                                        <TableCell align="center"><strong>No. (C)</strong></TableCell>
                                        <TableCell align="center"><strong>% (C/A)</strong></TableCell>
                                        <TableCell align="center"><strong>No.
                                            (D)
                                        </strong></TableCell>
                                        <TableCell align="center"><strong>% (D/A)
                                        </strong></TableCell>
                                        <TableCell align="center"><strong>No.
                                            (E)
                                        </strong></TableCell>
                                        <TableCell align="center"><strong>% (E/A)
                                        </strong></TableCell>
                                        <TableCell align="center"><strong>No.
                                            (F)
                                        </strong></TableCell>
                                        <TableCell align="center"><strong>% (F/A)
                                        </strong></TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody sx={{ "& tr": { borderBottom: "1px solid #C3C4BD" } }}>
                                    <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                        <TableCell component="th" scope="row" sx={{ width: 550, backgroundColor: "#e6e7e8" }} colSpan={12} align="center">
                                            <strong>Permanent Employees</strong>
                                        </TableCell>
                                    </TableRow>
                                    <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                        <TableCell component="th" scope="row">
                                            Male
                                        </TableCell>
                                        <TableCell align="center">14,476</TableCell>
                                        <TableCell align="center">14,476</TableCell>
                                        <TableCell align="center">100%</TableCell>
                                        <TableCell align="center">14,476</TableCell>
                                        <TableCell align="center">100%</TableCell>
                                        <TableCell align="center">NA</TableCell>
                                        <TableCell align="center">NA</TableCell>
                                        <TableCell align="center">14,476</TableCell>
                                        <TableCell align="center">100.00</TableCell>
                                        <TableCell align="center">0.00</TableCell>
                                        <TableCell align="center">0.00</TableCell>
                                    </TableRow>
                                    <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                        <TableCell component="th" scope="row">
                                            Female
                                        </TableCell>
                                        <TableCell align="center">2,166</TableCell>
                                        <TableCell align="center">2,166</TableCell>
                                        <TableCell align="center">100%</TableCell>
                                        <TableCell align="center">2,166</TableCell>
                                        <TableCell align="center">100%</TableCell>
                                        <TableCell align="center">2,166</TableCell>
                                        <TableCell align="center">100%</TableCell>
                                        <TableCell align="center">NA</TableCell>
                                        <TableCell align="center">NA</TableCell>
                                        <TableCell align="center">2,166</TableCell>
                                        <TableCell align="center">100.00</TableCell>
                                    </TableRow>
                                    <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                        <TableCell component="th" scope="row">
                                            Total
                                        </TableCell>
                                        <TableCell align="center">16,642</TableCell>
                                        <TableCell align="center">16,642</TableCell>
                                        <TableCell align="center">100%</TableCell>
                                        <TableCell align="center">16,642</TableCell>
                                        <TableCell align="center">100%</TableCell>
                                        <TableCell align="center">2,166</TableCell>
                                        <TableCell align="center">100%</TableCell>
                                        <TableCell align="center">14,476</TableCell>
                                        <TableCell align="center">100.00</TableCell>
                                        <TableCell align="center">2,166</TableCell>
                                        <TableCell align="center">13.02</TableCell>
                                    </TableRow>
                                    <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                        <TableCell component="th" scope="row" sx={{ width: 550, backgroundColor: "#e6e7e8" }} colSpan={12} align="center">
                                            <strong>Other than Permanent Employees</strong>
                                        </TableCell>
                                    </TableRow>
                                    <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                        <TableCell component="th" scope="row">
                                            Male
                                        </TableCell>
                                        <TableCell align="center">266</TableCell>
                                        <TableCell align="center">266</TableCell>
                                        <TableCell align="center">100%</TableCell>
                                        <TableCell align="center">266</TableCell>
                                        <TableCell align="center">100%</TableCell>
                                        <TableCell align="center">NA</TableCell>
                                        <TableCell align="center">NA</TableCell>
                                        <TableCell align="center">0.00</TableCell>
                                        <TableCell align="center">0.00</TableCell>
                                        <TableCell align="center">0.00</TableCell>
                                        <TableCell align="center">0.00</TableCell>
                                    </TableRow>
                                    <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                        <TableCell component="th" scope="row">
                                            Female
                                        </TableCell>
                                        <TableCell align="center">175</TableCell>
                                        <TableCell align="center">175</TableCell>
                                        <TableCell align="center">100%</TableCell>
                                        <TableCell align="center">175</TableCell>
                                        <TableCell align="center">100%</TableCell>
                                        <TableCell align="center">175</TableCell>
                                        <TableCell align="center">100%</TableCell>
                                        <TableCell align="center">NA</TableCell>
                                        <TableCell align="center">NA</TableCell>
                                        <TableCell align="center">175</TableCell>
                                        <TableCell align="center">100.00*</TableCell>
                                    </TableRow>
                                    <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                        <TableCell component="th" scope="row">
                                            Total
                                        </TableCell>
                                        <TableCell align="center">441</TableCell>
                                        <TableCell align="center">441</TableCell>
                                        <TableCell align="center">100%</TableCell>
                                        <TableCell align="center">441</TableCell>
                                        <TableCell align="center">100%</TableCell>
                                        <TableCell align="center">175</TableCell>
                                        <TableCell align="center">100%</TableCell>
                                        <TableCell align="center">0.00</TableCell>
                                        <TableCell align="center">0.00</TableCell>
                                        <TableCell align="center">175</TableCell>
                                        <TableCell align="center">39.68</TableCell>
                                    </TableRow>
                                </TableBody>
                            </Table>
                        </TableContainer>
                        <Box mt={1}>
                            <Typography variant='body2'>
                                Note: All employees are covered under wellbeing measures as per applicable legal requirements<br />
                                * The Company has established processes to ensure that requests for daycare facilities from female workers are duly considered and addressed wherever feasible and in line with applicable guidelines.
                            </Typography>
                        </Box>
                    </Box>
                </Collapse>
            </Box>
            <Box mt={2} sx={{ borderBottom: 1, borderColor: "#d3d3c8" }}>
                <Box mb={2}>
                    <Typography variant='body1' sx={{ fontWeight: 'bold', color: "#e31837" }}>
                        1. b. Details of measures for the well-being of workers.
                        <ExpandMore
                            expand={expanded2}
                            onClick={handleExpandClick2}
                            aria-expanded={expanded2}
                            aria-label="show more"
                        >
                            <ExpandMoreIcon />
                        </ExpandMore>
                    </Typography>
                </Box>
                <Collapse in={expanded2} timeout="auto" unmountOnExit>
                    <Box mb={5}>
                        <TableContainer component={Paper}>
                            <Table sx={{ minWidth: 650 }} size="small" aria-label="Water withdrawal">
                                <TableHead sx={{ "& th": { color: '#FFFFFF' } }}>
                                    <TableRow sx={{ backgroundColor: "#4d4d4f" }}>
                                        <TableCell align='center' rowSpan={3}><strong>Category</strong></TableCell>
                                        <TableCell align="center" colSpan={11}><strong>% of workers covered by</strong></TableCell>
                                    </TableRow>
                                    <TableRow sx={{ backgroundColor: "#4d4d4f" }}>
                                        <TableCell align='center' rowSpan={2}><strong>Total (A) </strong></TableCell>
                                        <TableCell align="center" colSpan={2}><strong>Health insurance</strong></TableCell>
                                        <TableCell align="center" colSpan={2}><strong>Accident insurance</strong></TableCell>
                                        <TableCell align="center" colSpan={2}><strong>Maternity benefits</strong></TableCell>
                                        <TableCell align="center" colSpan={2}><strong>Paternity Benefits</strong></TableCell>
                                        <TableCell align="center" colSpan={2}><strong>Day Care facilities</strong></TableCell>
                                    </TableRow>
                                    <TableRow sx={{ backgroundColor: "#4d4d4f" }}>
                                        <TableCell align="center"><strong>No. (B) </strong></TableCell>
                                        <TableCell align="center"><strong>% (B/A)</strong></TableCell>
                                        <TableCell align="center"><strong>No. (C)</strong></TableCell>
                                        <TableCell align="center"><strong>% (C/A)</strong></TableCell>
                                        <TableCell align="center"><strong>No.
                                            (D)
                                        </strong></TableCell>
                                        <TableCell align="center"><strong>% (D/A)
                                        </strong></TableCell>
                                        <TableCell align="center"><strong>No.
                                            (E)
                                        </strong></TableCell>
                                        <TableCell align="center"><strong>% (E/A)
                                        </strong></TableCell>
                                        <TableCell align="center"><strong>No.
                                            (F)
                                        </strong></TableCell>
                                        <TableCell align="center"><strong>% (F/A)
                                        </strong></TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody sx={{ "& tr": { borderBottom: "1px solid #C3C4BD" } }}>
                                    <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                        <TableCell component="th" scope="row" sx={{ width: 550, backgroundColor: "#e6e7e8" }} colSpan={12} align="center">
                                            <strong>Permanent Workers</strong>
                                        </TableCell>
                                    </TableRow>
                                    <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                        <TableCell component="th" scope="row">Male</TableCell>
                                        <TableCell align="center">10,060</TableCell>
                                        <TableCell align="center">10,060</TableCell>
                                        <TableCell align="center">100</TableCell>
                                        <TableCell align="center">10,060</TableCell>
                                        <TableCell align="center">100</TableCell>
                                        <TableCell align="center">NA</TableCell>
                                        <TableCell align="center">NA</TableCell>
                                        <TableCell align="center">0</TableCell>
                                        <TableCell align="center">0</TableCell>
                                        <TableCell align="center">0</TableCell>
                                        <TableCell align="center">0</TableCell>
                                    </TableRow>
                                    <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                        <TableCell component="th" scope="row">Female</TableCell>
                                        <TableCell align="center">63</TableCell>
                                        <TableCell align="center">63</TableCell>
                                        <TableCell align="center">100</TableCell>
                                        <TableCell align="center">63</TableCell>
                                        <TableCell align="center">100</TableCell>
                                        <TableCell align="center">63</TableCell>
                                        <TableCell align="center">100</TableCell>
                                        <TableCell align="center">NA</TableCell>
                                        <TableCell align="center">NA</TableCell>
                                        <TableCell align="center">63</TableCell>
                                        <TableCell align="center">100</TableCell>
                                    </TableRow>
                                    <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                        <TableCell component="th" scope="row">Total</TableCell>
                                        <TableCell align="center">10,123</TableCell>
                                        <TableCell align="center">10,123</TableCell>
                                        <TableCell align="center">100</TableCell>
                                        <TableCell align="center">10,123</TableCell>
                                        <TableCell align="center">100</TableCell>
                                        <TableCell align="center">63</TableCell>
                                        <TableCell align="center">100</TableCell>
                                        <TableCell align="center">0</TableCell>
                                        <TableCell align="center">0</TableCell>
                                        <TableCell align="center">63</TableCell>
                                        <TableCell align="center">0.62</TableCell>
                                    </TableRow>
                                    <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                        <TableCell component="th" scope="row" sx={{ width: 550, backgroundColor: "#e6e7e8" }} colSpan={12} align="center">
                                            <strong>Other than Permanent Workers</strong>
                                        </TableCell>
                                    </TableRow>
                                    <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                        <TableCell component="th" scope="row">Male</TableCell>
                                        <TableCell align="center">56,502</TableCell>
                                        <TableCell align="center">56,502</TableCell>
                                        <TableCell align="center">100</TableCell>
                                        <TableCell align="center">56,502</TableCell>
                                        <TableCell align="center">100</TableCell>
                                        <TableCell align="center">NA</TableCell>
                                        <TableCell align="center">NA</TableCell>
                                        <TableCell align="center">0</TableCell>
                                        <TableCell align="center">0</TableCell>
                                        <TableCell align="center">0</TableCell>
                                        <TableCell align="center">0</TableCell>
                                    </TableRow>
                                    <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                        <TableCell component="th" scope="row">Female</TableCell>
                                        <TableCell align="center">8,185</TableCell>
                                        <TableCell align="center">8,185</TableCell>
                                        <TableCell align="center">100</TableCell>
                                        <TableCell align="center">8,185</TableCell>
                                        <TableCell align="center">100</TableCell>
                                        <TableCell align="center">8,185</TableCell>
                                        <TableCell align="center">100</TableCell>
                                        <TableCell align="center">NA</TableCell>
                                        <TableCell align="center">NA</TableCell>
                                        <TableCell align="center">8,185</TableCell>
                                        <TableCell align="center">100</TableCell>
                                    </TableRow>
                                    <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                        <TableCell component="th" scope="row">Total</TableCell>
                                        <TableCell align="center">64,687</TableCell>
                                        <TableCell align="center">64,687</TableCell>
                                        <TableCell align="center">100</TableCell>
                                        <TableCell align="center">64,687</TableCell>
                                        <TableCell align="center">100</TableCell>
                                        <TableCell align="center">8,185</TableCell>
                                        <TableCell align="center">100</TableCell>
                                        <TableCell align="center">0</TableCell>
                                        <TableCell align="center">0</TableCell>
                                        <TableCell align="center">8,185</TableCell>
                                        <TableCell align="center">12.65</TableCell>
                                    </TableRow>
                                </TableBody>

                            </Table>
                        </TableContainer>
                        <Box mt={1}>
                            <Typography variant='body2'>
                                Note: All workers are covered under wellbeing measures as per applicable legal requirements
                            </Typography>
                        </Box>
                    </Box>
                </Collapse>
            </Box>
            <Box mt={2} sx={{ borderBottom: 1, borderColor: "#d3d3c8" }}>
                <Box mb={2}>
                    <Box>
                        <Typography variant='body1' sx={{ fontWeight: 'bold', color: "#e31837" }}>
                            1. c. Spending on measures towards well-being of employees and workers (including permanent and other than permanent) in the following format:
                            <ExpandMore
                                expand={expanded1c}
                                onClick={handleExpandClick1c}
                                aria-expanded={expanded1c}
                                aria-label="show more"
                            >
                                <ExpandMoreIcon />
                            </ExpandMore>
                        </Typography>
                    </Box>
                </Box>
                <Collapse in={expanded1c} timeout="auto" unmountOnExit>
                    <TableContainer component={Paper}>
                        <Table sx={{ minWidth: 650 }} size="small" >
                            <TableHead sx={{ "& th": { color: '#FFFFFF' } }}>
                                <TableRow sx={{ backgroundColor: "#4d4d4f" }}>
                                    <TableCell align="center"><strong></strong></TableCell>
                                    <TableCell align="center"><strong>FY25
                                    </strong></TableCell>
                                    <TableCell align="center"><strong>FY24
                                    </strong></TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody sx={{ "& tr": { borderBottom: "1px solid #C3C4BD" } }}>
                                <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                    <TableCell component="th" scope="row" >
                                        Cost incurred on well-being measures as a % of total
                                        revenue of the company
                                    </TableCell>
                                    <TableCell align='center'>0.51%</TableCell>
                                    <TableCell align='center'>0.34%</TableCell>
                                </TableRow>
                            </TableBody>
                        </Table>
                    </TableContainer>
                    <Box mb={5} mt={4}>

                    </Box>
                </Collapse>
            </Box>
            <Box mt={2} sx={{ borderBottom: 1, borderColor: "#d3d3c8" }}>
                <Box mb={2}>
                    <Box>
                        <Typography variant='body1' sx={{ fontWeight: 'bold', color: "#e31837" }}>
                            2. Details of retirement benefits, for Current FY and Previous Financial Year.
                            <ExpandMore
                                expand={expanded3}
                                onClick={handleExpandClick3}
                                aria-expanded={expanded3}
                                aria-label="show more"
                            >
                                <ExpandMoreIcon />
                            </ExpandMore>
                        </Typography>
                    </Box>
                </Box>
                <Collapse in={expanded3} timeout="auto" unmountOnExit>
                    <Box>
                        <TableContainer component={Paper} m>
                            <Table sx={{ minWidth: 650 }} size="small" >
                                <TableHead sx={{ "& th": { color: '#FFFFFF' } }}>
                                    <TableRow sx={{ backgroundColor: "#4d4d4f" }}>
                                        <TableCell align="center" rowSpan={2}><strong>Sr. No</strong></TableCell>
                                        <TableCell align="center" rowSpan={2}><strong>Benefits</strong></TableCell>
                                        <TableCell align='center' colSpan={3}><strong>FY25</strong>
                                        </TableCell>
                                        <TableCell align='center' colSpan={3}><strong>FY24*</strong>
                                        </TableCell>
                                    </TableRow>
                                    <TableRow sx={{ backgroundColor: "#4d4d4f" }}>
                                        <TableCell align="center" ><strong>No. of employees covered as a
                                            % of total employees.
                                        </strong></TableCell>
                                        <TableCell align="center" ><strong>No. of workers covered as a %
                                            of total workers.
                                        </strong></TableCell>
                                        <TableCell align="center" ><strong>Deducted and deposited with
                                            the authority (Y/N/NA).
                                        </strong></TableCell>
                                        <TableCell align="center" ><strong>No. of employees covered as a
                                            % of total employees.
                                        </strong></TableCell>
                                        <TableCell align="center" ><strong>No. of workers covered as a %
                                            of total workers.
                                        </strong></TableCell>
                                        <TableCell align="center" ><strong>Deducted and deposited with
                                            the authority (Y/N/NA).
                                        </strong></TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody sx={{ "& tr": { borderBottom: "1px solid #C3C4BD" } }}>
                                    <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                        <TableCell component="th" scope="row">1</TableCell>
                                        <TableCell align='center'>PF^</TableCell>
                                        <TableCell align='center'>100.00</TableCell>
                                        <TableCell align='center'>100.00</TableCell>
                                        <TableCell align='center'>Yes</TableCell>
                                        <TableCell align='center'>100.00</TableCell>
                                        <TableCell align='center'>100.00</TableCell>
                                        <TableCell align='center'>Yes</TableCell>
                                    </TableRow>
                                    <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                        <TableCell component="th" scope="row">2</TableCell>
                                        <TableCell align='center'>Gratuity^</TableCell>
                                        <TableCell align='center'>100.00</TableCell>
                                        <TableCell align='center'>100.00</TableCell>
                                        <TableCell align='center'>Yes</TableCell>
                                        <TableCell align='center'>100.00</TableCell>
                                        <TableCell align='center'>100.00</TableCell>
                                        <TableCell align='center'>Yes</TableCell>
                                    </TableRow>
                                    <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                        <TableCell component="th" scope="row">3</TableCell>
                                        <TableCell align='center'>ESI^</TableCell>
                                        <TableCell align='center'>NA</TableCell>
                                        <TableCell align='center'>100.00</TableCell>
                                        <TableCell align='center'>Yes</TableCell>
                                        <TableCell align='center'>NA</TableCell>
                                        <TableCell align='center'>100.00</TableCell>
                                        <TableCell align='center'>Yes</TableCell>
                                    </TableRow>
                                    <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                        <TableCell component="th" scope="row">4</TableCell>
                                        <TableCell align='center'>Other –<br />Please specify</TableCell>
                                        <TableCell align='center'>NA</TableCell>
                                        <TableCell align='center'>NA</TableCell>
                                        <TableCell align='center'>NA</TableCell>
                                        <TableCell align='center'>NA</TableCell>
                                        <TableCell align='center'>NA</TableCell>
                                        <TableCell align='center'>NA</TableCell>
                                    </TableRow>
                                </TableBody>

                            </Table>
                        </TableContainer>
                    </Box>
                    <Box mb={5} mt={1}>
                        <Typography variant='body2'>
                            ^All eligible employees and workers are covered
                        </Typography>
                    </Box>
                </Collapse>
            </Box>
            <Box mt={2} sx={{ borderBottom: 1, borderColor: "#d3d3c8" }}>
                <Box mb={2}>
                    <Box>
                        <Typography variant='body1' sx={{ fontWeight: 'bold', color: "#e31837" }}>
                            3. Are the premises/ offices of the entity accessible to differently abled employees and workers, as per the requirements of the Rights of Persons with Disabilities Act, 2016? If not, whether any steps are
                            being taken by the entity in this regard.
                            <ExpandMore
                                expand={expanded4}
                                onClick={handleExpandClick4}
                                aria-expanded={expanded4}
                                aria-label="show more"
                            >
                                <ExpandMoreIcon />
                            </ExpandMore>
                        </Typography>
                    </Box>
                </Box>
                <Collapse in={expanded4} timeout="auto" unmountOnExit>
                    <Box mb={5}>
                        <Typography variant='body1'>
                            Yes. The facilities are designed to ensure accessibility, including ramps, wider doorways, elevators, and designated restrooms for differently-abled individuals. Additionally, the Company ensures that all necessary adjustments are made to support employees with disabilities, enabling them to perform their duties effectively.
                        </Typography>
                    </Box>
                </Collapse>
            </Box>
            <Box mt={2} sx={{ borderBottom: 1, borderColor: "#d3d3c8" }}>
                <Box mb={2}>
                    <Box>
                        <Typography variant='body1' sx={{ fontWeight: 'bold', color: "#e31837" }}>
                            4. Does the entity have an equal opportunity policy as per the Rights of Persons with Disabilities Act, 2016? If so, provide a web-link to the policy.
                            <ExpandMore
                                expand={expanded5}
                                onClick={handleExpandClick5}
                                aria-expanded={expanded5}
                                aria-label="show more"
                            >
                                <ExpandMoreIcon />
                            </ExpandMore>
                        </Typography>
                    </Box>
                </Box>
                <Collapse in={expanded5} timeout="auto" unmountOnExit>
                    <Box mb={5}>
                        <Typography variant='body1'>
                            Yes, the Company has an Equal Opportunity Policy in place and ensures its implementation across the organization.
                        </Typography>
                    </Box>
                </Collapse>
            </Box>
            <Box mt={2} sx={{ borderBottom: 1, borderColor: "#d3d3c8" }}>
                <Box mb={2}>
                    <Box>
                        <Typography variant='body1' sx={{ fontWeight: 'bold', color: "#e31837" }}>
                            5. Return to work and Retention rates of permanent employees and workers that took parental leave.
                            <ExpandMore
                                expand={expanded6}
                                onClick={handleExpandClick6}
                                aria-expanded={expanded6}
                                aria-label="show more"
                            >
                                <ExpandMoreIcon />
                            </ExpandMore>
                        </Typography>
                    </Box>
                </Box>
                <Collapse in={expanded6} timeout="auto" unmountOnExit>
                    <Box mb={5}>
                        <TableContainer component={Paper} m>
                            <Table sx={{ minWidth: 650 }} size="small" >
                                <TableHead sx={{ "& th": { color: '#FFFFFF' } }}>
                                    <TableRow sx={{ backgroundColor: "#4d4d4f" }}>
                                        <TableCell rowSpan={2}><strong>Gender</strong></TableCell>
                                        <TableCell align="center" colSpan={2}><strong>Permanent employees
                                        </strong></TableCell>
                                        <TableCell align="center" colSpan={2}><strong>Permanent Workers*
                                        </strong></TableCell>
                                    </TableRow>
                                    <TableRow sx={{ backgroundColor: "#4d4d4f" }}>
                                        <TableCell align="center"><strong>Return-to-work rate
                                        </strong></TableCell>
                                        <TableCell align="center"><strong>Retention rate
                                        </strong></TableCell>
                                        <TableCell align="center"><strong>Return-to-work rate
                                        </strong></TableCell>
                                        <TableCell align="center"><strong>Retention rate
                                        </strong></TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody sx={{ "& tr": { borderBottom: "1px solid #C3C4BD" } }}>
                                    <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                        <TableCell component="th" scope="row">Male</TableCell>
                                        <TableCell align='center'>100%</TableCell>
                                        <TableCell align='center'>100%</TableCell>
                                        <TableCell align='center'>NA</TableCell>
                                        <TableCell align='center'>NA</TableCell>
                                    </TableRow>
                                    <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                        <TableCell component="th" scope="row">Female</TableCell>
                                        <TableCell align='center'>100%</TableCell>
                                        <TableCell align='center'>100%</TableCell>
                                        <TableCell align='center'>NA</TableCell>
                                        <TableCell align='center'>NA</TableCell>
                                    </TableRow>
                                    <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                        <TableCell component="th" scope="row">Total</TableCell>
                                        <TableCell align='center'>100%</TableCell>
                                        <TableCell align='center'>100%</TableCell>
                                        <TableCell align='center'>NA</TableCell>
                                        <TableCell align='center'>NA</TableCell>
                                    </TableRow>
                                </TableBody>

                            </Table>
                        </TableContainer>
                        <Box mt={1}>
                            <Typography variant='body2'>
                                * In FY 2025-26 no permanent worker availed parental leave.
                            </Typography>
                        </Box>
                    </Box>
                </Collapse>
            </Box>
            <Box mt={2} sx={{ borderBottom: 1, borderColor: "#d3d3c8" }}>
                <Box mb={2}>
                    <Box>
                        <Typography variant='body1' sx={{ fontWeight: 'bold', color: "#e31837" }}>
                            6. Is there a mechanism available to receive and redress grievances for the following categories of employees and worker? If yes, give details of the mechanism in brief.
                            <ExpandMore
                                expand={expanded7}
                                onClick={handleExpandClick7}
                                aria-expanded={expanded7}
                                aria-label="show more"
                            >
                                <ExpandMoreIcon />
                            </ExpandMore>
                        </Typography>
                    </Box>
                </Box>
                <Collapse in={expanded7} timeout="auto" unmountOnExit>
                    <Box mb={5}>
                        <Box mb={5}>
                            <Typography variant='body1'>
                                Yes
                            </Typography>
                        </Box>
                        <TableContainer component={Paper} m>
                            <Table sx={{ minWidth: 650 }} size="small" >
                                <TableHead sx={{ "& th": { color: '#FFFFFF' } }}>
                                    <TableRow sx={{ backgroundColor: "#4d4d4f" }}>
                                        <TableCell sx={{ width: '20%' }} rowSpan={2}><strong>Category</strong></TableCell>
                                        <TableCell sx={{ width: '20%' }} align="center" ><strong>Yes/No (If Yes, then give details of the mechanism in brief) </strong></TableCell>
                                        <TableCell sx={{ width: '60%' }} align="center" ><strong>Remark</strong></TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody sx={{ "& tr": { borderBottom: "1px solid #C3C4BD" } }}>
                                    <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                        <TableCell component="th" scope="row" >
                                            Permanent Workers
                                        </TableCell>
                                        <TableCell align="center">
                                            Yes
                                        </TableCell>
                                        <TableCell rowSpan={4}>
                                            The Company has a policy on Whistle-blower mechanism and Prevention of Sexual Harassment at Workplace (POSH) to provide a work environment that ensures all employees (permanent/ temporary including workers) at the workplace are treated with respect, dignity and are afforded equal as well as fair treatment.
                                            <br />
                                            Complaints relating to sexual harassment are handled by the respective region-wise Internal Committees under the Company's gender-neutral POSH policy.
                                            <br />
                                            The Whistle-Blower Policy establishes a vigil mechanism to report any other violations of the Company policies/unethical activities/applicable laws. These complaints are handled by the respective Ethics and Governance Committees.
                                        </TableCell>
                                    </TableRow>
                                    <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                        <TableCell component="th" scope="row" >
                                            Other than Permanent Workers
                                        </TableCell>
                                        <TableCell align="center">
                                            Yes
                                        </TableCell>
                                    </TableRow>
                                    <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                        <TableCell component="th" scope="row" >
                                            Permanent Employees
                                        </TableCell>
                                        <TableCell align="center">
                                            Yes
                                        </TableCell>
                                    </TableRow>
                                    <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                        <TableCell component="th" scope="row" >
                                            Other than Permanent Employees
                                        </TableCell>
                                        <TableCell align="center">
                                            Yes
                                        </TableCell>
                                    </TableRow>
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </Box>
                </Collapse>
            </Box>
            <Box mt={2} sx={{ borderBottom: 1, borderColor: "#d3d3c8" }}>
                <Box mb={2}>
                    <Box>
                        <Typography variant='body1' sx={{ fontWeight: 'bold', color: "#e31837" }}>
                            7. Membership of employees and worker in association(s) or Unions recognised by the listed entity:
                            <ExpandMore
                                expand={expanded8}
                                onClick={handleExpandClick8}
                                aria-expanded={expanded8}
                                aria-label="show more"
                            >
                                <ExpandMoreIcon />
                            </ExpandMore>
                        </Typography>
                    </Box>
                </Box>
                <Collapse in={expanded8} timeout="auto" unmountOnExit>
                    <TableContainer component={Paper} m>
                        <Table sx={{ minWidth: 650 }} size="small" >
                            <TableHead sx={{ "& th": { color: '#FFFFFF' } }}>
                                <TableRow sx={{ backgroundColor: "#4d4d4f" }}>
                                    <TableCell align="center" rowSpan={2}><strong>Category</strong></TableCell>
                                    <TableCell align="center" colSpan={3}><strong>FY 2025-26
                                    </strong></TableCell>
                                    <TableCell align="center" colSpan={3}><strong>FY 2024-25
                                    </strong></TableCell>
                                </TableRow>
                                <TableRow sx={{ backgroundColor: "#4d4d4f" }}>
                                    <TableCell align="center"><strong>Total employees/ workers
                                        in respective category
                                        (A)
                                    </strong></TableCell>
                                    <TableCell align="center"><strong>No. of employees/ workers in
                                        respective category, who are
                                        part of association(s) or
                                        Union
                                        (B)
                                    </strong></TableCell>
                                    <TableCell align="center"><strong>% (B/A)
                                    </strong></TableCell>
                                    <TableCell align="center"><strong>Total employees/ workers
                                        in respective category
                                        (C)
                                    </strong></TableCell>
                                    <TableCell align="center"><strong>No. of employees/ workers in
                                        respective category, who are
                                        part of association(s) or
                                        Union
                                        (D)
                                    </strong></TableCell>
                                    <TableCell align="center"><strong>% (D/C)
                                    </strong></TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody sx={{ "& tr": { borderBottom: "1px solid #C3C4BD" } }}>
                                <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                    <TableCell component="th" scope="row" align="center" colSpan={7} sx={{ backgroundColor: "#e6e7e8" }}>
                                        <strong>Permanent Employees</strong>
                                    </TableCell>
                                </TableRow>
                                <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                    <TableCell component="th" scope="row">Male</TableCell>
                                    <TableCell align='center'>14,476</TableCell>
                                    <TableCell align='center'>0</TableCell>
                                    <TableCell align='center'>0.00</TableCell>
                                    <TableCell align='center'>13,181</TableCell>
                                    <TableCell align='center'>0</TableCell>
                                    <TableCell align='center'>0.00</TableCell>
                                </TableRow>
                                <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                    <TableCell component="th" scope="row">Female</TableCell>
                                    <TableCell align='center'>2,166</TableCell>
                                    <TableCell align='center'>0</TableCell>
                                    <TableCell align='center'>0.00</TableCell>
                                    <TableCell align='center'>1,574</TableCell>
                                    <TableCell align='center'>0</TableCell>
                                    <TableCell align='center'>0.00</TableCell>
                                </TableRow>
                                <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                    <TableCell component="th" scope="row">Total</TableCell>
                                    <TableCell align='center'>16,642</TableCell>
                                    <TableCell align='center'>0</TableCell>
                                    <TableCell align='center'>0.00</TableCell>
                                    <TableCell align='center'>14,755</TableCell>
                                    <TableCell align='center'>0</TableCell>
                                    <TableCell align='center'>0.00</TableCell>
                                </TableRow>

                                <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                    <TableCell component="th" scope="row" align="center" colSpan={7} sx={{ backgroundColor: "#e6e7e8" }}>
                                        <strong>Permanent Workers</strong>
                                    </TableCell>
                                </TableRow>
                                <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                    <TableCell component="th" scope="row">Male</TableCell>
                                    <TableCell align='center'>10,060</TableCell>
                                    <TableCell align='center'>7,122</TableCell>
                                    <TableCell align='center'>70.80</TableCell>
                                    <TableCell align='center'>10,409</TableCell>
                                    <TableCell align='center'>8,602</TableCell>
                                    <TableCell align='center'>82.64</TableCell>
                                </TableRow>
                                <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                    <TableCell component="th" scope="row">Female</TableCell>
                                    <TableCell align='center'>63</TableCell>
                                    <TableCell align='center'>15</TableCell>
                                    <TableCell align='center'>23.81</TableCell>
                                    <TableCell align='center'>58</TableCell>
                                    <TableCell align='center'>13</TableCell>
                                    <TableCell align='center'>22.41</TableCell>
                                </TableRow>
                                <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                    <TableCell component="th" scope="row">Total</TableCell>
                                    <TableCell align='center'>10,123</TableCell>
                                    <TableCell align='center'>7,137</TableCell>
                                    <TableCell align='center'>70.50</TableCell>
                                    <TableCell align='center'>10,467</TableCell>
                                    <TableCell align='center'>8,615</TableCell>
                                    <TableCell align='center'>82.31</TableCell>
                                </TableRow>
                            </TableBody>
                        </Table>
                    </TableContainer>
                    <Box mb={5}>
                    </Box>
                </Collapse>
            </Box>
            <Box mt={2} sx={{ borderBottom: 1, borderColor: "#d3d3c8" }}>
                <Box mb={2}>
                    <Box>
                        <Typography variant='body1' sx={{ fontWeight: 'bold', color: "#e31837" }}>
                            8. Details of training given to employees and workers:
                            <ExpandMore
                                expand={expanded9}
                                onClick={handleExpandClick9}
                                aria-expanded={expanded9}
                                aria-label="show more"
                            >
                                <ExpandMoreIcon />
                            </ExpandMore>
                            <ExpandMore
                                expand={expanded9g}
                                onClick={handleExpandClick9g}
                                aria-expanded={expanded9g}
                                aria-label="show more"
                            >
                                <AssessmentOutlinedIcon />
                            </ExpandMore>
                        </Typography>
                    </Box>
                </Box>
                <Collapse in={expanded9} timeout="auto" unmountOnExit>
                    <TableContainer component={Paper} m>
                        <Table sx={{ minWidth: 650 }} size="small" >
                            <TableHead sx={{ "& th": { color: '#FFFFFF' } }}>
                                <TableRow sx={{ backgroundColor: "#4d4d4f" }}>
                                    <TableCell align="center" rowSpan={3}><strong>Category</strong></TableCell>
                                    <TableCell align="center" colSpan={5}><strong>FY 2025-26*
                                    </strong></TableCell>
                                    <TableCell align="center" colSpan={5}><strong>FY 2024-25
                                    </strong></TableCell>
                                </TableRow>
                                <TableRow sx={{ backgroundColor: "#4d4d4f" }}>
                                    <TableCell align="center" rowSpan={2}><strong>Total (A)
                                    </strong></TableCell>
                                    <TableCell align="center" colSpan={2}><strong>On Health and safety measures
                                    </strong></TableCell>
                                    <TableCell align="center" colSpan={2}><strong>On Skill upgradation
                                    </strong></TableCell>
                                    <TableCell align="center" rowSpan={2}><strong>Total (D)
                                    </strong></TableCell>
                                    <TableCell align="center" colSpan={2}><strong>On Health and safety measures
                                    </strong></TableCell>
                                    <TableCell align="center" colSpan={2}><strong>On Skill upgradation
                                    </strong></TableCell>
                                </TableRow>
                                <TableRow sx={{ backgroundColor: "#4d4d4f" }}>
                                    <TableCell align="center"><strong>No. (B)
                                    </strong></TableCell>
                                    <TableCell align="center"><strong>% (B / A)
                                    </strong></TableCell>
                                    <TableCell align="center"><strong>No. (C) </strong></TableCell>
                                    <TableCell align="center"><strong>% (C / A)
                                    </strong></TableCell>
                                    <TableCell align="center"><strong>No. (E)
                                    </strong></TableCell>
                                    <TableCell align="center"><strong>% (E / D)
                                    </strong></TableCell>
                                    <TableCell align="center"><strong>No. (F) </strong></TableCell>
                                    <TableCell align="center"><strong>% (F / D)
                                    </strong></TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody sx={{ "& tr": { borderBottom: "1px solid #C3C4BD" } }}>
                                <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                    <TableCell component="th" scope="row" colSpan={11} align="center" sx={{ backgroundColor: "#e6e7e8" }}>
                                        <strong>Employees</strong>
                                    </TableCell>
                                </TableRow>
                                <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                    <TableCell component="th" scope="row">Male</TableCell>
                                    <TableCell align='center'>14,742</TableCell>
                                    <TableCell align='center'>14,742</TableCell>
                                    <TableCell align='center'>100</TableCell>
                                    <TableCell align='center'>12,680</TableCell>
                                    <TableCell align='center'>86.01</TableCell>
                                    <TableCell align='center'>13,472</TableCell>
                                    <TableCell align='center'>12,819</TableCell>
                                    <TableCell align='center'>95.15</TableCell>
                                    <TableCell align='center'>11,564</TableCell>
                                    <TableCell align='center'>85.84</TableCell>
                                </TableRow>
                                <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                    <TableCell component="th" scope="row">Female</TableCell>
                                    <TableCell align='center'>2,341</TableCell>
                                    <TableCell align='center'>2,341</TableCell>
                                    <TableCell align='center'>100</TableCell>
                                    <TableCell align='center'>2,043</TableCell>
                                    <TableCell align='center'>87.27</TableCell>
                                    <TableCell align='center'>1,747</TableCell>
                                    <TableCell align='center'>1,577</TableCell>
                                    <TableCell align='center'>90.27</TableCell>
                                    <TableCell align='center'>1,567</TableCell>
                                    <TableCell align='center'>89.70</TableCell>
                                </TableRow>
                                <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                    <TableCell component="th" scope="row">Total</TableCell>
                                    <TableCell align='center'>17,083</TableCell>
                                    <TableCell align='center'>17,083</TableCell>
                                    <TableCell align='center'>100</TableCell>
                                    <TableCell align='center'>14,723</TableCell>
                                    <TableCell align='center'>86.19</TableCell>
                                    <TableCell align='center'>15,219</TableCell>
                                    <TableCell align='center'>14,396</TableCell>
                                    <TableCell align='center'>94.59</TableCell>
                                    <TableCell align='center'>13,131</TableCell>
                                    <TableCell align='center'>86.28</TableCell>
                                </TableRow>

                                <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                    <TableCell component="th" scope="row" colSpan={11} align="center" sx={{ backgroundColor: "#e6e7e8" }}>
                                        <strong>Workers</strong>
                                    </TableCell>
                                </TableRow>
                                <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                    <TableCell component="th" scope="row">Male</TableCell>
                                    <TableCell align='center'>66,562</TableCell>
                                    <TableCell align='center'>66,562</TableCell>
                                    <TableCell align='center'>100</TableCell>
                                    <TableCell align='center'>37,601</TableCell>
                                    <TableCell align='center'>56.49</TableCell>
                                    <TableCell align='center'>56,915</TableCell>
                                    <TableCell align='center'>53,225</TableCell>
                                    <TableCell align='center'>93.52</TableCell>
                                    <TableCell align='center'>29,254</TableCell>
                                    <TableCell align='center'>51.40</TableCell>
                                </TableRow>
                                <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                    <TableCell component="th" scope="row">Female</TableCell>
                                    <TableCell align='center'>8,248</TableCell>
                                    <TableCell align='center'>8,248</TableCell>
                                    <TableCell align='center'>100</TableCell>
                                    <TableCell align='center'>5,988</TableCell>
                                    <TableCell align='center'>72.60</TableCell>
                                    <TableCell align='center'>6,622</TableCell>
                                    <TableCell align='center'>4,900</TableCell>
                                    <TableCell align='center'>74.00</TableCell>
                                    <TableCell align='center'>4,851</TableCell>
                                    <TableCell align='center'>73.25</TableCell>
                                </TableRow>
                                <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                    <TableCell component="th" scope="row">Total</TableCell>
                                    <TableCell align='center'>74,810</TableCell>
                                    <TableCell align='center'>74,810</TableCell>
                                    <TableCell align='center'>100</TableCell>
                                    <TableCell align='center'>43,589</TableCell>
                                    <TableCell align='center'>58.27</TableCell>
                                    <TableCell align='center'>63,537</TableCell>
                                    <TableCell align='center'>58,125</TableCell>
                                    <TableCell align='center'>91.48</TableCell>
                                    <TableCell align='center'>34,105</TableCell>
                                    <TableCell align='center'>53.67</TableCell>
                                </TableRow>
                            </TableBody>
                        </Table>
                    </TableContainer>
                    <Box mb={5} mt={1}>
                        <Typography variant='body2'>
                            * Permanent as well as other than permanent employees and workers have been considered while arriving at the %.
                        </Typography>
                    </Box>
                </Collapse>
                <Collapse in={expanded9g} timeout="auto" unmountOnExit>
                    <Box sx={{ mx: 'auto', width: { md: '100%', lg: '70%' } }} mt={4} mb={8}>

                        <Box p={3} sx={{ backgroundColor: '#e31837' }} display='flex' flexDirection='column' alignItems='center' justifyContent='center'>
                            <Box>
                                <Typography variant='h6' sx={{ color: 'white', fontWeight: 'bold' }}>
                                    Health and Safety Trainings - Workers
                                </Typography>
                            </Box>
                            <Box mt={1}>
                                <Typography variant='body2' sx={{ color: 'white' }}>
                                    Increased worker coverage for training
                                </Typography>
                            </Box>
                        </Box>
                        <Box p={6} sx={{ border: "1.5px solid #e31837" }}>
                            <Box sx={{ overflowX: 'auto', width: '100%' }}>
                                <Box sx={{ minWidth: '600px', height: '350px' }}>
                                    <Bar options={options1} data={data1} />
                                </Box>
                            </Box>
                        </Box>
                    </Box>
                </Collapse>
            </Box>
            <Box mt={2} sx={{ borderBottom: 1, borderColor: "#d3d3c8" }}>
                <Box mb={2}>
                    <Box>
                        <Typography variant='body1' sx={{ fontWeight: 'bold', color: "#e31837" }}>
                            9. Details of performance and career development reviews of employees and workers
                            <ExpandMore
                                expand={expanded10}
                                onClick={handleExpandClick10}
                                aria-expanded={expanded10}
                                aria-label="show more"
                            >
                                <ExpandMoreIcon />
                            </ExpandMore>
                        </Typography>
                    </Box>
                </Box>
                <Collapse in={expanded10} timeout="auto" unmountOnExit>
                    <TableContainer component={Paper} m>
                        <Table sx={{ minWidth: 650 }} size="small" >
                            <TableHead sx={{ "& th": { color: '#FFFFFF' } }}>
                                <TableRow sx={{ backgroundColor: "#4d4d4f" }}>
                                    <TableCell align="center" rowSpan={2}><strong>Category</strong></TableCell>
                                    <TableCell align="center" colSpan={3}><strong>FY 2025-26
                                    </strong></TableCell>
                                    <TableCell align="center" colSpan={3}><strong>FY 2024-25
                                    </strong></TableCell>
                                </TableRow>
                                <TableRow sx={{ backgroundColor: "#4d4d4f" }}>
                                    <TableCell align="center"><strong>Total (A)
                                    </strong></TableCell>
                                    <TableCell align="center"><strong>No. (B)
                                    </strong></TableCell>
                                    <TableCell align="center"><strong>% (B / A) </strong></TableCell>
                                    <TableCell align="center"><strong>Total (C)
                                    </strong></TableCell>
                                    <TableCell align="center"><strong>No. (D)
                                    </strong></TableCell>
                                    <TableCell align="center"><strong>% (D / C)
                                    </strong></TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody sx={{ "& tr": { borderBottom: "1px solid #C3C4BD" } }}>
                                <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                    <TableCell component="th" scope="row" colSpan={7} align="center" sx={{ backgroundColor: "#e6e7e8" }}>
                                        <strong>Employees</strong>
                                    </TableCell>
                                </TableRow>
                                <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                    <TableCell component="th" scope="row">Male</TableCell>
                                    <TableCell align='center'>14,476</TableCell>
                                    <TableCell align='center'>14,476</TableCell>
                                    <TableCell align='center'>100.00</TableCell>
                                    <TableCell align='center'>13,181</TableCell>
                                    <TableCell align='center'>13,181</TableCell>
                                    <TableCell align='center'>100.00</TableCell>
                                </TableRow>
                                <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                    <TableCell component="th" scope="row">Female</TableCell>
                                    <TableCell align='center'>2,166</TableCell>
                                    <TableCell align='center'>2,166</TableCell>
                                    <TableCell align='center'>100.00</TableCell>
                                    <TableCell align='center'>1,574</TableCell>
                                    <TableCell align='center'>1,574</TableCell>
                                    <TableCell align='center'>100.00</TableCell>
                                </TableRow>
                                <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                    <TableCell component="th" scope="row">Total</TableCell>
                                    <TableCell align='center'>16,642</TableCell>
                                    <TableCell align='center'>16,642</TableCell>
                                    <TableCell align='center'>100.00</TableCell>
                                    <TableCell align='center'>14,755</TableCell>
                                    <TableCell align='center'>14,755</TableCell>
                                    <TableCell align='center'>100.00</TableCell>
                                </TableRow>

                                <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                    <TableCell component="th" scope="row" colSpan={7} align="center" sx={{ backgroundColor: "#e6e7e8" }}>
                                        <strong>Workers</strong>
                                    </TableCell>
                                </TableRow>
                                <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                    <TableCell component="th" scope="row">Male</TableCell>
                                    <TableCell align='center'>10,060</TableCell>
                                    <TableCell align='center'>1,892</TableCell>
                                    <TableCell align='center'>18.80</TableCell>
                                    <TableCell align='center'>10,409</TableCell>
                                    <TableCell align='center'>1,125</TableCell>
                                    <TableCell align='center'>10.81</TableCell>
                                </TableRow>
                                <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                    <TableCell component="th" scope="row">Female</TableCell>
                                    <TableCell align='center'>63</TableCell>
                                    <TableCell align='center'>31</TableCell>
                                    <TableCell align='center'>49.20</TableCell>
                                    <TableCell align='center'>58</TableCell>
                                    <TableCell align='center'>31</TableCell>
                                    <TableCell align='center'>53.45</TableCell>
                                </TableRow>
                                <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                    <TableCell component="th" scope="row">Total</TableCell>
                                    <TableCell align='center'>10,123</TableCell>
                                    <TableCell align='center'>1,923</TableCell>
                                    <TableCell align='center'>19.00</TableCell>
                                    <TableCell align='center'>10,467</TableCell>
                                    <TableCell align='center'>1,156</TableCell>
                                    <TableCell align='center'>11.04</TableCell>
                                </TableRow>
                            </TableBody>

                        </Table>
                    </TableContainer>
                    <Box mb={5}>
                    </Box>
                </Collapse>
            </Box>
            <Box mt={2} sx={{ borderBottom: 1, borderColor: "#d3d3c8" }}>
                <Box mb={2}>
                    <Box>
                        <Typography variant='body1' sx={{ fontWeight: 'bold', color: "#e31837" }}>
                            10. Health and safety management system
                            <ExpandMore
                                expand={expanded12}
                                onClick={handleExpandClick12}
                                aria-expanded={expanded12}
                                aria-label="show more"
                            >
                                <ExpandMoreIcon />
                            </ExpandMore>
                        </Typography>
                    </Box>
                </Box>
                <Collapse in={expanded12} timeout="auto" unmountOnExit>
                    <Box mb={5}>
                        <TableContainer component={Paper} m>
                            <Table sx={{ minWidth: 650 }} size="small" >
                                <TableBody sx={{ "& tr": { border: "1px solid #C3C4BD" } }}>
                                    <TableRow>
                                        <TableCell component="th" scope="row" sx={{ backgroundColor: "#e6e7e8", border: "1px solid #C3C4BD" }}>
                                            <strong>
                                                a. Whether an occupational health and safety management system has been implemented by the entity? (Yes/ No). If yes, the coverage of such system?
                                            </strong>
                                        </TableCell>
                                        <TableCell>
                                            Yes. All plants are ISO 45001: 2018 certified / Re-certified for OHSMS by M/s TuV Nord and BSI.
                                        </TableCell>
                                    </TableRow>

                                    <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                        <TableCell component="th" scope="row" sx={{ backgroundColor: "#e6e7e8", border: "1px solid #C3C4BD" }}>
                                            <strong>
                                                b. What are the processes used to identify work-related hazards and assess risks on a routine and non-routine basis by the entity?
                                            </strong>
                                        </TableCell>
                                        <TableCell>
                                            The Company has established a comprehensive and structured approach to identify work-related hazards and assess risks for both routine and non-routine activities across all facilities.
                                            <br />
                                            <strong>1. Systematic Hazard Identification and Risk Assessment</strong>
                                            <ul>
                                                <li>Hazard Identification &amp; Risk Assessment – Control (HIRA-C) is conducted for all routine and non-routine activities at plant level.</li>
                                                <li>Process Hazard Analysis including HAZOP, QRA, and HIRA, as applicable to operations.</li>
                                                <li>Task Analysis and Job Safety Analysis (JSA) is carried out for specific tasks and activities to identify task-level hazards.</li>
                                                <li>Aspect and Impact Assessments are undertaken to evaluate operational safety and environmental risks.</li>
                                            </ul>

                                            <strong>2. Change and Non-Routine Activity Management</strong>
                                            <ul>
                                                <li>Management of Change (MOC) process implemented to identify and mitigate risks arising from changes in processes, equipment, or operating conditions.</li>
                                                <li>Permit-to-Work (PTW) system strictly followed for high-risk and non-routine activities to ensure appropriate controls and authorisations.</li>
                                            </ul>

                                            <strong>3. Inspections, Audits and Assessments</strong>
                                            <ul>
                                                <li>Internal and external safety audits, including specialised electrical safety audits and fire safety audits, undertaken periodically.</li>
                                                <li>Safety assessments and surveys carried out to evaluate workplace conditions and risk exposure.</li>
                                            </ul>

                                            <strong>4. Governance and Review Mechanisms</strong>
                                            <ul>
                                                <li>Plant-level Safety Committee meetings for site-specific hazard identification and corrective action tracking.</li>
                                                <li>Department-level Safety Sub-Committee (SSC) meetings to address functional safety risks.</li>
                                                <li>Sector Safety SPOC fortnightly review meetings to monitor trends and key risk areas.</li>
                                            </ul>

                                            <strong>5. Leadership Engagement and Observations</strong>
                                            <ul>
                                                <li>Safety Observation Tours (SoT) conducted by management to identify unsafe acts and conditions and reinforce safety culture.</li>
                                                <li>“Rise with Safety” monthly review meetings led by senior leadership to review critical safety risks across business divisions.</li>
                                            </ul>
                                        </TableCell>
                                    </TableRow>

                                    <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                        <TableCell component="th" scope="row" sx={{ backgroundColor: "#e6e7e8", border: "1px solid #C3C4BD" }}>
                                            <strong>
                                                c. Whether you have processes for workers to report the work related hazards and to remove themselves from such risks. (Yes/ No)
                                            </strong>
                                        </TableCell>
                                        <TableCell>
                                            Yes, A Plant Safety Committee is constituted at each manufacturing plant in accordance with the Factories Act, 1948, providing a formal forum for workers to raise safety-related concerns, report hazards, and discuss corrective actions. M&amp;M also has the following processes in place:
                                            <br />
                                            <strong>1. Hazard Identification and Risk Mitigation Process</strong>
                                            <ul>
                                                <li>Standard Operating Procedure for Identification of works related identified Hazards and Risk Mitigation Plan.</li>
                                                <li>Workmen participation and involvement in Job Safety Analysis and Safety Committee Meetings for identification of Hazards / Risks and implementation of effective control measures.</li>
                                                <li>Robust Work Permit System followed for critical identified operations.</li>
                                            </ul>

                                            <strong>2. Reporting, Monitoring, and Preventive Mechanisms</strong>
                                            <ul>
                                                <li>Safety concerns are discussed in daily work management (DWM) for the plant critical observations across departments are discussed, employees also participate in Safety observation tour (SOT) identification &amp; elimination of Unsafe acts, Unsafe conditions &amp; At-Risk behaviours.</li>
                                                <li>Near-miss Incident Reporting and action towards completion is in place.</li>
                                                <li>CCTV Observations and completion actions in place.</li>
                                            </ul>

                                            <strong>3. Employee Engagement and Safety Culture</strong>
                                            <ul>
                                                <li>Safety Employee of the month is declared every month who works towards safety.</li>
                                                <li>At manufacturing locations, various annual events like Road Safety Week, National Safety Day/Month and Fire Service Week were celebrated.</li>
                                            </ul>

                                            <strong>4. Training and Capability Building</strong>
                                            <ul>
                                                <li>Regular training programmes on safety, health, and environment are conducted, supported by on-the-job training (OJT) and virtual reality (VR) based learning modules for competency building.</li>
                                                <li>At Abhiyantriki, safety, health, and environment competency-building initiatives include dexterity training programmes for associates.</li>
                                                <li>Special focus is placed on safety and fire safety through the introduction of Self-Managed Teams (SMTs), aligned with the Company’s sustainability roadmap.</li>
                                            </ul>
                                        </TableCell>
                                    </TableRow>

                                    <TableRow>
                                        <TableCell component="th" scope="row" sx={{ backgroundColor: "#e6e7e8", border: "1px solid #C3C4BD" }}>
                                            <strong>
                                                d. Do the employees/ worker of the entity have access to non-occupational medical and healthcare services? (Yes/ No)
                                            </strong>
                                        </TableCell>
                                        <TableCell>
                                            Yes, the annual medical examination conducted for all employees include early identification and diagnosis of lifestyle diseases (non-occupational diseases). The health index of the working population is derived from the annual medical examination every year. Other than lifestyle diseases it includes addressal of sleep disorders and abnormal eating habits.
                                        </TableCell>
                                    </TableRow>
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </Box>
                </Collapse>
            </Box>
            <Box mt={2} sx={{ borderBottom: 1, borderColor: "#d3d3c8" }}>
                <Box mb={2}>
                    <Box>
                        <Typography variant='body1' sx={{ fontWeight: 'bold', color: "#e31837" }}>
                            11. Details of safety related incidents, in the following format:
                            <ExpandMore
                                expand={expanded15}
                                onClick={handleExpandClick15}
                                aria-expanded={expanded15}
                                aria-label="show more"
                            >
                                <ExpandMoreIcon />
                            </ExpandMore>
                        </Typography>
                    </Box>
                </Box>
                <Collapse in={expanded15} timeout="auto" unmountOnExit>
                    <Box mb={5}>
                        <TableContainer component={Paper}>
                            <Table sx={{ minWidth: 650 }} size="small" >
                                <TableHead sx={{ "& th": { color: '#FFFFFF' } }}>
                                    <TableRow sx={{ backgroundColor: "#4d4d4f" }}>
                                        <TableCell sx={{ width: '40%' }} align="left"><strong>Safety Incident/ Number</strong></TableCell>
                                        <TableCell sx={{ width: '20%' }} align="center"><strong>Category</strong></TableCell>
                                        <TableCell sx={{ width: '20%' }} align="center"><strong>FY 2025-26</strong></TableCell>
                                        <TableCell sx={{ width: '20%' }} align="center"><strong>FY 2024-25</strong></TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody sx={{ "& tr": { borderBottom: "1px solid #C3C4BD" } }}>
                                    <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                        <TableCell component="th" scope="row" rowSpan={2}>
                                            Lost Time Injury Frequency Rate (LTIFR) (per one million-person hours worked)
                                        </TableCell>
                                        <TableCell align='center'>Employees</TableCell>
                                        <TableCell align='center'>0</TableCell>
                                        <TableCell align='center'>0</TableCell>
                                    </TableRow>
                                    <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                        <TableCell align='center'>Workers</TableCell>
                                        <TableCell align='center'>0.07</TableCell>
                                        <TableCell align='center'>0.09</TableCell>
                                    </TableRow>

                                    <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                        <TableCell component="th" scope="row" rowSpan={2}>
                                            Total recordable work-related injuries
                                        </TableCell>
                                        <TableCell align='center'>Employees</TableCell>
                                        <TableCell align='center'>0</TableCell>
                                        <TableCell align='center'>0</TableCell>
                                    </TableRow>
                                    <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                        <TableCell align='center'>Workers</TableCell>
                                        <TableCell align='center'>6</TableCell>
                                        <TableCell align='center'>9</TableCell>
                                    </TableRow>

                                    <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                        <TableCell component="th" scope="row" rowSpan={2}>
                                            No. of fatalities
                                        </TableCell>
                                        <TableCell align='center'>Employees</TableCell>
                                        <TableCell align='center'>0</TableCell>
                                        <TableCell align='center'>0</TableCell>
                                    </TableRow>
                                    <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                        <TableCell align='center'>Workers</TableCell>
                                        <TableCell align='center'>0</TableCell>
                                        <TableCell align='center'>0</TableCell>
                                    </TableRow>

                                    <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                        <TableCell component="th" scope="row" rowSpan={2}>
                                            High consequence work-related injury or ill-health (excluding fatalities)
                                        </TableCell>
                                        <TableCell align='center'>Employees</TableCell>
                                        <TableCell align='center'>0</TableCell>
                                        <TableCell align='center'>0</TableCell>
                                    </TableRow>
                                    <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                        <TableCell align='center'>Workers</TableCell>
                                        <TableCell align='center'>0</TableCell>
                                        <TableCell align='center'>0</TableCell>
                                    </TableRow>
                                </TableBody>
                            </Table>
                        </TableContainer>
                        <Box mt={1}>
                            <Typography variant='body2'>
                                * Including in the contract workforce
                            </Typography>
                        </Box>
                    </Box>
                </Collapse>
            </Box>
            <Box mt={2} sx={{ borderBottom: 1, borderColor: "#d3d3c8" }}>
                <Box mb={2}>
                    <Box>
                        <Typography variant='body1' sx={{ fontWeight: 'bold', color: "#e31837" }}>
                            12. Describe the measures taken by the entity to ensure a safe and healthy work place.
                            <ExpandMore
                                expand={expanded16}
                                onClick={handleExpandClick16}
                                aria-expanded={expanded16}
                                aria-label="show more"
                            >
                                <ExpandMoreIcon />
                            </ExpandMore>
                        </Typography>
                    </Box>
                </Box>
                <Collapse in={expanded16} timeout="auto" unmountOnExit>
                    <Box mb={5}>
                        <Typography variant='body1'>
                            The Company has implemented a comprehensive and multi-layered occupational health and safety framework to ensure a safe and healthy workplace for employees and associates. The key measures include the following:
                            <br />
                            <br />
                            <strong>1. Awareness and Capacity Building</strong>
                            <ul>
                                <li>Mandatory safety induction for all new joinees prior to commencement of work.</li>
                                <li>Comprehensive safety training for employees and contract associates at Abhiyantriki, including induction, refresher, dexterity, and on-the-job training, followed by safety assessments.</li>
                                <li>Toolbox Talks conducted regularly, with special focus on high-risk activities.</li>
                                <li>Continuous safety awareness through Mahindra Life Saving Principles (MLSP) and structured safety communication initiatives.</li>
                                <li>Behaviour-Based Safety (BBS) implementation, including regular safety observations by management.</li>
                            </ul>

                            <strong>2. Hazard Identification, Audits and Inspection</strong>
                            <ul>
                                <li>Periodic internal and external safety audits, including walk-through audits to identify unsafe conditions across workplaces.</li>
                                <li>Dedicated fire safety audits and electrical safety audits conducted at defined intervals.</li>
                                <li>Theme-based safety campaigns and monthly safety themes deployed across plants and sectors for focused risk mitigation.</li>
                                <li>Routine safety inspections, HIRA sheets, and Job Safety Analysis (JSA) at plant and departmental levels.</li>
                            </ul>

                            <strong>3. Risk Management</strong>
                            <ul>
                                <li>Daily Work Management (DWM) system for tracking and closure of safety observations daily.</li>
                                <li>Management of Change (MOC) process, gap audits, safe operating procedures, and pre-startup and shutdown safety protocols.</li>
                                <li>Permit-to-Work (PTW) system, including Lockout-Tagout-Tryout (LOTOTO), for high-risk and non-routine jobs.</li>
                                <li>Critical equipment and machinery check to ensure mechanical integrity and safe operations.</li>
                            </ul>

                            <strong>4. Emergency Preparedness</strong>
                            <ul>
                                <li>Structured incident investigation and corrective action mechanisms.</li>
                                <li>On-site emergency preparedness plans, mock drills, and response evaluations.</li>
                                <li>Contractor Safety Management, including competency assessments, safety training, and compliance monitoring.</li>
                                <li>Robust Legal and Compliance Management Systems, with monthly certifications generated through M-Compliance and E-Compliance portals.</li>
                            </ul>

                            <strong>5. Occupational Health Monitoring</strong>
                            <ul>
                                <li>Periodic environmental monitoring and measurements for noise, heat, ventilation, air quality, and water, conducted as per scheduled programs.</li>
                                <li>Health and safety surveys to assess workplace exposure and risks.</li>
                            </ul>
                        </Typography>
                    </Box>
                </Collapse>
            </Box>
            <Box mt={2} sx={{ borderBottom: 1, borderColor: "#d3d3c8" }}>
                <Box mb={2}>
                    <Box>
                        <Typography variant='body1' sx={{ fontWeight: 'bold', color: "#e31837" }}>
                            13. Number of complaints on the following made by employees and workers
                            <ExpandMore
                                expand={expanded17}
                                onClick={handleExpandClick17}
                                aria-expanded={expanded17}
                                aria-label="show more"
                            >
                                <ExpandMoreIcon />
                            </ExpandMore>
                        </Typography>
                    </Box>
                </Box>
                <Collapse in={expanded17} timeout="auto" unmountOnExit>
                    <Box mb={5}>
                        <TableContainer component={Paper} m>
                            <Table sx={{ minWidth: 650 }} size="small" >
                                <TableHead sx={{ "& th": { color: '#FFFFFF' } }}>
                                    <TableRow sx={{ backgroundColor: "#4d4d4f" }}>
                                        <TableCell align="center" rowSpan={2}><strong></strong></TableCell>
                                        <TableCell align="center" colSpan={3}><strong>FY 2025-26
                                        </strong></TableCell>
                                        <TableCell align="center" colSpan={3}><strong>FY 2024-25
                                        </strong></TableCell>
                                    </TableRow>
                                    <TableRow sx={{ backgroundColor: "#4d4d4f" }}>
                                        <TableCell align="center"><strong>Filed during the year
                                        </strong></TableCell>
                                        <TableCell align="center"><strong>Pending resolution at the end of year
                                        </strong></TableCell>
                                        <TableCell align="center"><strong>Remark
                                        </strong></TableCell>
                                        <TableCell align="center"><strong>Filed during the year
                                        </strong></TableCell>
                                        <TableCell align="center"><strong>Pending resolution at the end of year
                                        </strong></TableCell>
                                        <TableCell align="center"><strong>Remark
                                        </strong></TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody sx={{ "& tr": { borderBottom: "1px solid #C3C4BD" } }}>
                                    <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                        <TableCell component="th" scope="row">
                                            Working Conditions
                                        </TableCell>
                                        <TableCell align='center'>0
                                        </TableCell>
                                        <TableCell align='center'>0
                                        </TableCell>
                                        <TableCell align='center'>NA
                                        </TableCell>
                                        <TableCell align='center'>0
                                        </TableCell>
                                        <TableCell align='center'>0
                                        </TableCell>
                                        <TableCell align='center'>NA
                                        </TableCell>
                                    </TableRow>
                                    <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                        <TableCell component="th" scope="row">
                                            Health & Safety
                                        </TableCell>
                                        <TableCell align='center'>0
                                        </TableCell>
                                        <TableCell align='center'>0
                                        </TableCell>
                                        <TableCell align='center'>NA
                                        </TableCell>
                                        <TableCell align='center'>0
                                        </TableCell>
                                        <TableCell align='center'>0
                                        </TableCell>
                                        <TableCell align='center'>NA
                                        </TableCell>
                                    </TableRow>
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </Box>
                </Collapse>
            </Box>
            <Box mt={2} sx={{ borderBottom: 1, borderColor: "#d3d3c8" }}>
                <Box mb={2}>
                    <Box>
                        <Typography variant='body1' sx={{ fontWeight: 'bold', color: "#e31837" }}>
                            14. Assessments for the year:
                            <ExpandMore
                                expand={expanded18}
                                onClick={handleExpandClick18}
                                aria-expanded={expanded18}
                                aria-label="show more"
                            >
                                <ExpandMoreIcon />
                            </ExpandMore>
                        </Typography>
                    </Box>
                </Box>
                <Collapse in={expanded18} timeout="auto" unmountOnExit>
                    <TableContainer component={Paper} m>
                        <Table sx={{ minWidth: 650 }} size="small" >
                            <TableHead sx={{ "& th": { color: '#FFFFFF' } }}>
                                <TableRow sx={{ backgroundColor: "#4d4d4f" }}>
                                    <TableCell align="center"><strong>Topic</strong></TableCell>
                                    <TableCell align="center" ><strong>% of your plants and offices that were assessed (by entity or statutory authorities or third parties)
                                    </strong></TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody sx={{ "& tr": { borderBottom: "1px solid #C3C4BD" } }}>
                                <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                    <TableCell component="th" scope="row">
                                        Health and safety practices
                                    </TableCell>
                                    <TableCell align='center'>100.00
                                    </TableCell>
                                </TableRow>
                                <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                    <TableCell component="th" scope="row">
                                        Working Conditions
                                    </TableCell>
                                    <TableCell align='center'>100.00</TableCell>
                                </TableRow>
                            </TableBody>
                        </Table>
                    </TableContainer>
                    <Box mb={5}>
                    </Box>
                </Collapse>
            </Box>
            <Box mt={2} sx={{ borderBottom: 1, borderColor: "#d3d3c8" }}>
                <Box mb={2}>
                    <Box>
                        <Typography variant='body1' sx={{ fontWeight: 'bold', color: "#e31837" }}>
                            15. Provide details of any corrective action taken or underway to address safety-related incidents (if any) and on significant risks/ concerns arising from assessments of health & safety practices and
                            working conditions.
                            <ExpandMore
                                expand={expanded19}
                                onClick={handleExpandClick19}
                                aria-expanded={expanded19}
                                aria-label="show more"
                            >
                                <ExpandMoreIcon />
                            </ExpandMore>
                        </Typography>
                    </Box>
                </Box>
                <Collapse in={expanded19} timeout="auto" unmountOnExit>
                    <Box mb={5}>
                        <Typography variant='body1'>
                            <strong>HIRA-C</strong> is a dynamic and live document that is periodically updated and reviewed to ensure safety across all routine and non-routine operations performed in the plant. In the event of a Near Miss or Injury Incident, detailed investigation by cross-functional teams carried out to identify root causes to prevent recurrence and the HIRA sheets are revised with adequate control measures for performing the respective activity. Adequate control measures are accordingly implemented to address risks and ensure safe execution of the respective activity.
                        </Typography>
                    </Box>
                </Collapse>
            </Box>
            <Box mt={6}>
                <Typography className='heading' variant='h4' sx={{ fontSize: '28px', color: "#e31837" }}>
                    Leadership Indicators
                </Typography>
            </Box>
            <Box mt={2} sx={{ borderBottom: 1, borderColor: "#d3d3c8" }}>
                <Box mb={2}>
                    <Box>
                        <Typography variant='body1' sx={{ fontWeight: 'bold', color: "#e31837" }}>
                            1. Does the entity extend any life insurance or any compensatory package in the event of death of (A) Employees (Y/N) (B) Workers (Y/N).
                            <ExpandMore
                                expand={expanded20}
                                onClick={handleExpandClick20}
                                aria-expanded={expanded20}
                                aria-label="show more"
                            >
                                <ExpandMoreIcon />
                            </ExpandMore>
                        </Typography>
                    </Box>
                </Box>
                <Collapse in={expanded20} timeout="auto" unmountOnExit>
                    <Box mb={5}>
                        <Typography variant='body1'>
                            A. Employees - Yes <br></br><br></br>
                            B. Workers - Yes
                        </Typography>
                    </Box>
                </Collapse>
            </Box>
            <Box mt={2} sx={{ borderBottom: 1, borderColor: "#d3d3c8" }}>
                <Box mb={2}>
                    <Box>
                        <Typography variant='body1' sx={{ fontWeight: 'bold', color: "#e31837" }}>
                            2. Provide the measures undertaken by the entity to ensure that statutory dues have been deducted and deposited by the value chain partners.
                            <ExpandMore
                                expand={expanded21}
                                onClick={handleExpandClick21}
                                aria-expanded={expanded21}
                                aria-label="show more"
                            >
                                <ExpandMoreIcon />
                            </ExpandMore>
                        </Typography>
                    </Box>
                </Box>
                <Collapse in={expanded21} timeout="auto" unmountOnExit>
                    <Box mb={5}>
                        <Typography variant='body1'>
                            The Company has set stringent Code of Conduct (CoC) for all supplier partners. This Code of Conduct is signed by most of our suppliers. M&amp;M Code of conduct includes clauses like regulatory compliance, human rights, respect &amp; dignity, no child or forced labor, minimum wages, hours of work, accounting and reporting, bribery, corruption &amp; money laundering, tax laws compliance.
                            <br /><br />
                            Also, we conduct third party on-site ESG audits at identified and prioritized suppliers to verify the compliance. This audit covers compliance related topics such as Provident Fund and Miscellaneous Provisions act, 1952, Child Labour (Prohibition and Regulation) Act, 1986; Employees State Insurance Act, 1948; Minimum Wages Act, 1948; Payments of Wages Act, 1936; Payment of Bonus Act, 1965; Payment of Gratuity Act, 1972; Leave and workmen’s compensation for accidents, etc.
                        </Typography>
                    </Box>
                </Collapse>
            </Box>
            <Box mt={2} sx={{ borderBottom: 1, borderColor: "#d3d3c8" }}>
                <Box mb={2}>
                    <Box>
                        <Typography variant='body1' sx={{ fontWeight: 'bold', color: "#e31837" }}>
                            3. Provide the number of employees/ workers having suffered high consequence work-related injury/ ill-health/ fatalities (as reported in Q11 of Essential Indicators above), who have been are
                            rehabilitated and placed in suitable employment or whose family members have been placed in suitable employment:
                            <ExpandMore
                                expand={expanded22}
                                onClick={handleExpandClick22}
                                aria-expanded={expanded22}
                                aria-label="show more"
                            >
                                <ExpandMoreIcon />
                            </ExpandMore>
                        </Typography>
                    </Box>
                </Box>
                <Collapse in={expanded22} timeout="auto" unmountOnExit>
                    <Box mb={5}>
                        <TableContainer component={Paper} m>
                            <Table sx={{ minWidth: 650 }} size="small" >
                                <TableHead sx={{ "& th": { color: '#FFFFFF' } }}>
                                    <TableRow sx={{ backgroundColor: "#4d4d4f" }}>
                                        <TableCell align="center" rowSpan={2}><strong></strong></TableCell>
                                        <TableCell align="center" colSpan={2}><strong>Total no. of affected employees/ workers
                                        </strong></TableCell>
                                        <TableCell align="center" colSpan={2} width='200'><strong>No. of employees/workers that are
                                            rehabilitated and placed in suitable
                                            employment or whose family members have
                                            been placed in suitable employment
                                        </strong></TableCell>
                                    </TableRow>
                                    <TableRow sx={{ backgroundColor: "#4d4d4f" }}>
                                        <TableCell align="center"><strong>FY 2025-26
                                        </strong></TableCell>
                                        <TableCell align="center"><strong>FY 2024-25
                                        </strong></TableCell>
                                        <TableCell align="center"><strong>FY 2025-26
                                        </strong></TableCell>
                                        <TableCell align="center"><strong>FY 2024-25
                                        </strong></TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody sx={{ "& tr": { borderBottom: "1px solid #C3C4BD" } }}>
                                    <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                        <TableCell component="th" scope="row" align='center'>
                                            Employees
                                        </TableCell>
                                        <TableCell align='center'>0</TableCell>
                                        <TableCell align='center'>0</TableCell>
                                        <TableCell align='center'>0</TableCell>
                                        <TableCell align='center'>0</TableCell>

                                    </TableRow>
                                    <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                        <TableCell component="th" scope="row" align='center'>
                                            Workers
                                        </TableCell>
                                        <TableCell align='center'>0</TableCell>
                                        <TableCell align='center'>0</TableCell>
                                        <TableCell align='center'>0</TableCell>
                                        <TableCell align='center'>0</TableCell>
                                    </TableRow>
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </Box>
                </Collapse>
            </Box>
            <Box mt={2} sx={{ borderBottom: 1, borderColor: "#d3d3c8" }}>
                <Box mb={2}>
                    <Box>
                        <Typography variant='body1' sx={{ fontWeight: 'bold', color: "#e31837" }}>
                            4. Does the entity provide transition assistance programs to facilitate continued employability and the management of career endings resulting from retirement or termination of employment? (Yes/ No)

                            <ExpandMore
                                expand={expanded23}
                                onClick={handleExpandClick23}
                                aria-expanded={expanded23}
                                aria-label="show more"
                            >
                                <ExpandMoreIcon />
                            </ExpandMore>
                        </Typography>
                    </Box>
                </Box>
                <Collapse in={expanded23} timeout="auto" unmountOnExit>
                    <Box mb={5}>
                        <Typography variant='body1'>
                            Yes, for all employees transitioning into retirement, the Company offers comprehensive workshops and seminars focused
                            on post-retirement financial and health management. <br></br><br></br>
                            In case of separations, as applicable, severance packages are offered to departing employees. In certain cases, retiring
                            employees are hired back on a contract basis, in an advisory capacity.
                        </Typography>
                    </Box>
                </Collapse>
            </Box>
            <Box mt={2} sx={{ borderBottom: 1, borderColor: "#d3d3c8" }}>
                <Box mb={2}>
                    <Box>
                        <Typography variant='body1' sx={{ fontWeight: 'bold', color: "#e31837" }}>
                            5. Details on assessment of value chain partners:
                            <ExpandMore
                                expand={expanded24}
                                onClick={handleExpandClick24}
                                aria-expanded={expanded24}
                                aria-label="show more"
                            >
                                <ExpandMoreIcon />
                            </ExpandMore>
                        </Typography>
                    </Box>
                </Box>
                <Collapse in={expanded24} timeout="auto" unmountOnExit>
                    <Box mb={5}>
                        <Box mb={5}>
                            <Typography variant='body1'>
                                The Company enforces an ESG-aligned Supplier Code of Conduct and works with suppliers who share the Company’s values and culture of fair, ethical, and responsible business practices. Over a period, 95% of suppliers by its purchase value signed the Supplier Code of Conduct, affirming their compliance with key health, safety, and labour standards, including provisions related to occupational health and safety and workplace well-being.
                                <br /><br />
                                The Company conducts onsite safety audits at prioritized suppliers through renowned third-party agencies. These third-party audits cover various aspects such as occupational health, safety, employee well-being and working conditions. The Company initiated safety audits in FY 2020-21. Till date audits have been completed for 67% of suppliers, by value. In FY 2025-26, the Company conducted audits of 13% of suppliers, by value. The Company also initiated safety audits for tier-2 suppliers in this financial year.
                                <br /><br />
                                The Company initiated ESG due diligence in FY 2023-24, which was continued through FY26. Cumulatively, due diligence has been completed for 68.1% of suppliers, by value, since FY 2023-24. During FY 2025-26, ESG due diligence was conducted for 11.9% of suppliers, by value.
                                <br /><br />
                                The ESG due diligence of suppliers is aimed at strengthening responsible sourcing efforts. It involves an assessment of employee health and safety, employee wellbeing, environmental impact, working conditions, and other relevant environmental, social, and governance aspects. The due-diligence process also evaluates critical safety and labour parameters, including occupational safety practices, working conditions, and minimum wage compliance.
                            </Typography>
                        </Box>

                        <TableContainer component={Paper} m>
                            <Table sx={{ minWidth: 650 }} size="small" >
                                <TableHead sx={{ "& th": { color: '#FFFFFF' } }}>
                                    <TableRow sx={{ backgroundColor: "#4d4d4f" }}>
                                        <TableCell sx={{ width: '40%' }}><strong>Topic</strong></TableCell>
                                        <TableCell sx={{ width: '60%' }}><strong>% of value chain partners (by value of business done with such partners) that were assessed
                                        </strong></TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody sx={{ "& tr": { borderBottom: "1px solid #C3C4BD" } }}>
                                    <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                        <TableCell component="th" scope="row">
                                            Health and safety practices
                                        </TableCell>
                                        <TableCell>
                                            <li>13% in FY 2025-26</li>
                                            <li>67% Cumulatively from FY 2020-21</li>
                                        </TableCell>
                                    </TableRow>
                                    <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                        <TableCell component="th" scope="row">
                                            Working Conditions
                                        </TableCell>
                                        <TableCell>
                                            <li>11.9% in FY 2025-26</li>
                                            <li>68.1% Cumulatively from FY 2023-24</li>
                                        </TableCell>
                                    </TableRow>
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </Box>
                </Collapse>
            </Box>
            <Box mt={2} mb={5} sx={{ borderBottom: 1, borderColor: "#d3d3c8" }}>
                <Box mb={2}>
                    <Box>
                        <Typography variant='body1' sx={{ fontWeight: 'bold', color: "#e31837" }}>
                            6. Provide details of any corrective actions taken or underway to address significant risks/ concerns arising from assessments of health and safety practices and working conditions of value chain partners.
                            <ExpandMore
                                expand={expanded25}
                                onClick={handleExpandClick25}
                                aria-expanded={expanded25}
                                aria-label="show more"
                            >
                                <ExpandMoreIcon />
                            </ExpandMore>
                        </Typography>
                    </Box>
                </Box>
                <Collapse in={expanded25} timeout="auto" unmountOnExit>
                    <Box mb={5}>
                        <Typography variant='body1'>
                            There were no significant risks/concerns noticed during onsite supplier assessments with regards to occupational health, safety and working conditions. However, for the supplier audits where minor concerns were observed related to safety at supplier location, the suppliers have submitted the corrective action plans. The implementation of action plans and its effectiveness is verified through re-audits.
                            <br /><br />
                            As a proactive measure to strengthen safety practices across the value chain, the company also undertakes structured training and awareness programmes on health, safety, and working conditions for suppliers. These programmes are designed to enhance supplier awareness, reinforce compliance with applicable standards, and promote continuous improvement in workplace health and safety performance.
                        </Typography>
                    </Box>
                </Collapse>
            </Box>
        </Container>
    )
}


export default Sectionc3;